/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React from 'react';
import { Grid, Tooltip } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { Drawer, IconButton, MenuItem } from '@mui/material';
import { BsFillHouseFill, BsFillPeopleFill, BsGridFill } from "react-icons/bs";
import { FaBell } from 'react-icons/fa';
import { MdPets } from 'react-icons/md';
const drawerWidth = 80;

const MenuSideBar = () => {
    const { classes } = useStyles();
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Drawer
            anchor={"left"}
            open={true}
            variant="persistent"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    border: '1px solid rgba(144, 202, 249, 0.46)',
                    borderRadius: '0px',
                    height: 'calc(100% - 300px)',
                    top: 110,
                    position: 'absolute',
                    overflowY: "inherit"

                },
            }}
        >

            <Grid container spacing={4} style={{ paddingTop: '20px' }}>
                <Grid item xs={12} sm={12} md={12} >
                    <Tooltip title="Dashboard" placement="right" arrow>
                        <div>

                            <MenuItem className={classes.barMenuItem}
                                style={{ background: location.pathname === "/dashboard" || location.pathname === "/" ? 'rgb(243 195 195)' : "white" }}
                                onClick={() => { navigate("/dashboard") }}>
                                <IconButton color="primary">
                                    <BsFillHouseFill />
                                </IconButton>
                            </MenuItem>
                        </div>
                    </Tooltip>
                    <Tooltip title="Users" placement="right" arrow>
                        <div>

                            <MenuItem className={classes.barMenuItem}
                                style={{ background: location.pathname === "/manage-users" || location.pathname === "/" ? 'rgb(243 195 195)' : "white" }}
                                onClick={() => { navigate("/manage-users") }}>
                                <IconButton color="primary">
                                    <BsFillPeopleFill />
                                </IconButton>
                            </MenuItem>
                        </div>
                    </Tooltip>
                    <Tooltip title="Pets" placement="right" arrow>
                        <div>

                            <MenuItem className={classes.barMenuItem}
                                style={{ background: location.pathname === "/manage-pets" ? 'rgb(243 195 195)' : "white" }}
                                onClick={() => { navigate("/manage-pets") }}>
                                <IconButton color="primary">
                                    <MdPets />
                                </IconButton>
                            </MenuItem>
                        </div>
                    </Tooltip>
                    <Tooltip title="Posts" placement="right" arrow>
                        <div>

                            <MenuItem className={classes.barMenuItem}
                                style={{ background: location.pathname === "/manage-posts" ? 'rgb(243 195 195)' : "white" }}
                                onClick={() => { navigate("/manage-posts") }}>
                                <IconButton color="primary">
                                    <BsGridFill />
                                </IconButton>
                            </MenuItem>
                        </div>
                    </Tooltip>
                    <Tooltip title="Notifications" placement="right" arrow>
                        <div>

                            <MenuItem className={classes.barMenuItem}
                                style={{ background: location.pathname === "/manage-notifications" ? 'rgb(243 195 195)' : "white" }}
                                onClick={() => { navigate("/manage-notifications") }}>
                                <IconButton color="primary">
                                    <FaBell />
                                </IconButton>
                            </MenuItem>
                        </div>
                    </Tooltip>
                </Grid>



            </Grid>
        </Drawer>
    )
}

const useStyles = makeStyles({ "name": { MenuSideBar } })((theme) => ({

    barMenuItem: {
        padding: '20px!important',
        "&:hover": {
            background: theme.palette.success.main
        }
    },
    barMenuItemTypo: {
        paddingLeft: '5px!important',
        "&:hover": {
            color: 'white!important'
        }
    },
    BarIcon: {
        marginBottom: '-3px',
        marginRight: '29px'
    }

}));
export default MenuSideBar
